/* VLS: keep the active thumbnail in view in the vertical (left) thumbnail column (mobile + desktop). */
(function () {
  if (window.__vlsThumbVScrollInit) return;
  window.__vlsThumbVScrollInit = true;

  function needsScroll(container, item) {
    if (container.scrollWidth > container.clientWidth + 2) { /* 28/09/2026 : vignettes horizontales sous l'image */
      var l = container.scrollLeft, r = l + container.clientWidth;
      return item.offsetLeft < l || item.offsetLeft + item.offsetWidth > r;
    }
    var cTop = container.scrollTop;
    var cBottom = cTop + container.clientHeight;
    var iTop = item.offsetTop;
    var iBottom = iTop + item.offsetHeight;
    return iTop < cTop || iBottom > cBottom;
  }

  function vScroll(container, item) {
    if (container.scrollWidth > container.clientWidth + 2) {
      var x = item.offsetLeft - (container.clientWidth - item.offsetWidth) / 2;
      container.scrollTo({ left: x < 0 ? 0 : x, behavior: 'smooth' });
      return;
    }
    var target = item.offsetTop - (container.clientHeight - item.offsetHeight) / 2;
    if (target < 0) target = 0;
    container.scrollTo({ top: target, behavior: 'smooth' });
  }

  function setup(gallery) {
    var container = gallery.querySelector('.media-thumbs');
    if (!container || container.dataset.vlsVscroll) return;
    container.dataset.vlsVscroll = '1';

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.classList && t.classList.contains('is-active')) {
          var item = t.closest('.media-thumbs__item');
          if (item && needsScroll(container, item)) vScroll(container, item);
        }
      }
    });

    obs.observe(container, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('.product-media--slider .media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
}());
